import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api, fmtBRL, fmtDate } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Payments() {
  const [items, setItems] = useState([]);
  const [clients, setClients] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const load = async () => {
    const [p, c] = await Promise.all([
      api.get("/payments", { params: { from_date: from, to_date: to } }),
      api.get("/clients"),
    ]);
    setItems(p.data); setClients(c.data);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  const cName = (id) => clients.find(c => c.id === id)?.nome || "—";

  const remove = async (p) => {
    if (!window.confirm(`Estornar recebimento de ${fmtBRL(p.valor)}? A parcela voltará a ficar pendente e a comissão gerada será removida.`)) return;
    try { await api.delete(`/payments/${p.id}`); toast.success("Recebimento estornado"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  const total = items.reduce((a, p) => a + p.valor, 0);

  return (
    <Layout title="Recebimentos" subtitle="Histórico de pagamentos recebidos">
      <Card className="p-4 rounded-sm mb-4">
        <div className="flex items-end justify-between gap-3 flex-wrap">
          <div className="flex items-end gap-3">
            <div><Label className="text-xs font-semibold">De</Label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="mt-1"/></div>
            <div><Label className="text-xs font-semibold">Até</Label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="mt-1"/></div>
            <Button onClick={load} data-testid="payments-apply">Aplicar</Button>
          </div>
          <div className="text-right">
            <p className="text-[10px] uppercase tracking-[0.18em] font-bold text-muted-foreground">Total</p>
            <p className="kpi-num text-2xl mt-1 text-emerald-700">{fmtBRL(total)}</p>
          </div>
        </div>
      </Card>
      <Card className="rounded-sm overflow-hidden">
        <Table>
          <TableHeader className="bg-secondary/60"><TableRow>
            <TableHead>Data</TableHead><TableHead>Cliente</TableHead>
            <TableHead>Valor</TableHead><TableHead>Forma</TableHead>
            <TableHead>Observações</TableHead><TableHead className="text-right">Ações</TableHead>
          </TableRow></TableHeader>
          <TableBody>{items.map(p => (
            <TableRow key={p.id} data-testid={`payment-row-${p.id}`}>
              <TableCell>{fmtDate(p.data)}</TableCell>
              <TableCell>{cName(p.cliente_id)}</TableCell>
              <TableCell className="font-semibold text-emerald-700">{fmtBRL(p.valor)}</TableCell>
              <TableCell><Badge variant="secondary" className="capitalize">{p.forma_pagamento}</Badge></TableCell>
              <TableCell className="text-xs text-muted-foreground">{p.observacoes || "—"}</TableCell>
              <TableCell className="text-right">
                <Button data-testid={`payment-delete-${p.id}`} variant="ghost" size="sm" onClick={() => remove(p)}><Trash2 className="w-4 h-4"/></Button>
              </TableCell>
            </TableRow>
          ))}{items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-6">Nenhum recebimento</TableCell></TableRow>}</TableBody>
        </Table>
      </Card>
    </Layout>
  );
}
